// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import ReactDOM from 'react-dom';
interface AutoCompleteProps {
    displayProp?: string;
    datasource?: any[];
    parameters?: any;
    searchProperty?: string;
    minLength: number;
    onChange?: any;
    initialValue?: string;
    onEnterPressed?: any;
    templateFunction?: any;
    template?: string;
    placeholder?: string;
    getDataCallback?: (params: any, success: (data: any) => void, error: (error: any) => void) => void;
}


class AutoComplete extends React.Component<AutoCompleteProps, any> {
    private _randId: any;
    constructor(props: AutoCompleteProps) {
        super(props);

        this._randId = (Math.random() + (new Date()).getUTCMilliseconds()).toString().replace('.', '-');
    }

    private _onKeyDown = (e: any) => {
        if (e.which === kendo.keys.ENTER) {
            if (this.props.onEnterPressed) {
                this.props.onEnterPressed();
            }
        }
    }

    private _readDataFromDataSource = (options: any) => {
        var params = {...this.props.parameters}
        if (this.props.searchProperty) {
            params[this.props.searchProperty] = options.data.filter.filters[0].value.trim();
        }

        this.props.getDataCallback(params, options.success, options.error);
    }

    private _getDataSource = (props: any) => {
        var urlOptions: any = {
            serverFiltering: true,
            serverPaging: true,
            transport: {
                read: this._readDataFromDataSource
            }
        };

        return new kendo.data.DataSource(urlOptions);
    }

    private _setOptions = (options: any, props: AutoCompleteProps) => {
        options.minLength = props.minLength;

        if (options.minLength > 0) {
            options.filtering = function (e: any) {
                if (e.filter.value.length == 0) {
                    e.sender.close();
                    e.preventDefault();
                }
            };
        }

        if (props.onChange) {
            options.change = function (e: any) {
                props.onChange(this.value());
            };

            options.select = function (e: any) {
                var item = e.item;
                props.onChange(item.text());
                props.onEnterPressed();
            };

            options.close = function (e: any) {
                props.onChange(this.value());
            };
        }

        if (props.displayProp) {
            options.dataTextField = props.displayProp;
        }

        if (props.template) {
            options.template = props.template;
        } else if (props.templateFunction) {
            options.template = "#var tOut = $('\\#" + this._randId + "').data('kendoAutoComplete').React.props.templateFunction(data); ##=tOut#";
        }
    }

    componentDidMount() {
        var options: any = {
            filter: "contains"
        };

        if (this.props.datasource) {
            options.dataSource = this.props.datasource;
        }
        else {
            options.dataSource = this._getDataSource(this.props);
        }

        this._setOptions(options, this.props);

        var container = $(ReactDOM.findDOMNode(this)) as any;
        container.kendoAutoComplete(options);

        var kendoAutoComplete = container.data('kendoAutoComplete');
        (kendoAutoComplete as any).React = this;

        if (this.props.initialValue || this.props.initialValue === "") {
            container.data('kendoAutoComplete').value(this.props.initialValue);
        }

        // This fixes an issue (bug in Kendo DropDown control?), where a scroll bar
        // is not automatically added if the number of items in the list exceeds
        // the control's height, causing the items to "overflow" the boundaries
        // of the control.
        kendoAutoComplete.ul.css("max-height", kendoAutoComplete.options.height + "px");
    }

    componentWillUnmount() {
        var autoComplete = $(ReactDOM.findDOMNode(this)).data('kendoAutoComplete');
        autoComplete.destroy();
    }

    UNSAFE_componentWillReceiveProps(nextProps: AutoCompleteProps) {
        var kendoAutoComplete = $(ReactDOM.findDOMNode(this)).data('kendoAutoComplete');
        this._setOptions(kendoAutoComplete.options, nextProps);

        var dataSource: any;
        if (this.props.datasource) {
            dataSource = this.props.datasource;
        }
        else {
            dataSource = this._getDataSource(nextProps);
        }

        kendoAutoComplete.setDataSource(dataSource);
        kendoAutoComplete.refresh();

        if (nextProps.initialValue || nextProps.initialValue === "") {
            kendoAutoComplete.value(nextProps.initialValue);
        }
    }

    render() {
        return <input id={this._randId} className={'auto-complete'} onKeyDown={this._onKeyDown} placeholder={this.props.placeholder} />;
    }

}

export default AutoComplete;